import { useCallback, useEffect, useMemo, useState } from 'react';
import { useGetMatnrIntegrationStatusListMutation } from '../../../../api';

const useMatnrIntegrationStatusData = () => {
    const [getMatnrIntegrationStatusList, { data, isLoading }] = useGetMatnrIntegrationStatusListMutation();

    const [rawRows, setRawRows] = useState([]); 
    const [totalRecords, setTotalRecords] = useState(0);

    const [filters, setFilters] = useState({
        matnr: null,
    });

    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 1,
        sortField: null,
        sortOrder: null,
    });

    const [hasApplied, setHasApplied] = useState(true);

    const queryBody = useMemo(() => ({
        pageNumber: lazyParams.page,
        pageSize: lazyParams.rows,
        matnr: filters.matnr ?? undefined,
    }), [lazyParams.page, lazyParams.rows, filters.matnr]);

    useEffect(() => {
        if (hasApplied) {
            getMatnrIntegrationStatusList(queryBody);
        }
    }, [hasApplied, queryBody, getMatnrIntegrationStatusList]);

    useEffect(() => {
        if (data) {
            setRawRows(Array.isArray(data.items) ? data.items : []);
            setTotalRecords(data.totalCount || 0);
        }
    }, [data]);

    // ✅ Frontend'de sıralama
    const rows = useMemo(() => {
        if (!lazyParams.sortField || !lazyParams.sortOrder) return rawRows;

        return [...rawRows].sort((a, b) => {
            let aVal = a[lazyParams.sortField];
            let bVal = b[lazyParams.sortField];

            if (aVal == null && bVal == null) return 0;
            if (aVal == null) return lazyParams.sortOrder;
            if (bVal == null) return -lazyParams.sortOrder;

            const strA = String(aVal).toLowerCase();
            const strB = String(bVal).toLowerCase();
            return lazyParams.sortOrder * strA.localeCompare(strB, 'tr-TR');
        });
    }, [rawRows, lazyParams.sortField, lazyParams.sortOrder]);

    const handleApplyFilters = useCallback((newFilters) => {
        setFilters({
            matnr: newFilters.matnr,
        });
        setLazyParams(prev => ({ ...prev, first: 0, page: 1 }));
        setHasApplied(true);
    }, []);

    const handleResetFilters = useCallback(() => {
        setFilters({
            matnr: null,
        });
        setLazyParams({
            first: 0,
            rows: 10,
            page: 1,
            sortField: null,
            sortOrder: null,
        });
        setHasApplied(true);
    }, []);

    const onPage = useCallback((event) => {
        setLazyParams(prev => ({
            ...prev,
            first: event.first,
            rows: event.rows,
            page: event.page + 1,
        }));
    }, []);

    const onSort = useCallback((event) => {
        setLazyParams(prev => ({
            ...prev,
            sortField: event.sortField,
            sortOrder: event.sortOrder,
        }));
    }, []);

    const loading = isLoading;

    return {
        rows,
        totalRecords,
        loading,
        filters,
        lazyParams,
        onPage,
        onSort,
        handleApplyFilters,
        handleResetFilters,
    };
};

export default useMatnrIntegrationStatusData;